import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestConversoresEntradaSaida({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'conversores', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteConversorEntradaSaida({ payload }) {
  try {
    const { idconversor, params } = payload;
    let { idposto } = payload;

    if (!idposto) {
      const state = yield select((store) => store.conversorEntradaSaida);

      const item = state.data.find(
        (d) => Number(d.idconversor) === Number(idconversor)
      );

      idposto = item?.idposto;
    }

    yield call(api.delete, `conversores/${idconversor}/${idposto}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(t(e)));
    else toast.error(t(erros));
  }
}

export function* storeConversorEntradaSaida({ payload }) {
  try {
    const { conversorEntradaSaida, params } = payload;

    yield call(api.post, 'conversores', conversorEntradaSaida);
    yield put(successRequest(null));
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/conversores');
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { idconversor } = payload;
    let { idposto } = payload;

    if (!idposto) {
      const state = yield select((store) => store.conversorEntradaSaida);

      const item = state.data.find(
        (d) => Number(d.idconversor) === Number(idconversor)
      );

      idposto = item?.idposto;
    }

    const { data } = yield call(
      api.get,
      `conversores/${idconversor}/${idposto}`
    );

    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { conversorEntradaSaida, params } = payload;

    yield call(api.put, 'conversores', conversorEntradaSaida);
    yield put(successRequest(null));
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/conversores');
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'conversores', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest(
    '@conversorEntradaSaida/CONVERSORES_ENTRADA_SAIDA_IN_REQUEST',
    requestConversoresEntradaSaida
  ),
  takeLatest(
    '@conversorEntradaSaida/DELETE_CONVERSOR_ENTRADA_SAIDA',
    deleteConversorEntradaSaida
  ),
  takeLatest(
    '@conversorEntradaSaida/SUCCESS_REMOVE',
    requestConversoresEntradaSaida
  ),
  takeLatest(
    '@conversorEntradaSaida/STORE_CONVERSOR_ENTRADA_SAIDA',
    storeConversorEntradaSaida
  ),
  takeLatest('@conversorEntradaSaida/FIND_CONVERSOR_ENTRADA_SAIDA', find),
  takeLatest('@conversorEntradaSaida/UPDATE_CONVERSOR_ENTRADA_SAIDA', update),
  takeLatest('@conversorEntradaSaida/RECORD_FILTERING', applyedFilters),
]);
